
import { Component, ComponentProps } from "react";
import { District } from "@/models/common";
import { AsyncSelect, FetchUserError, OptionMeta } from "./AsyncSelect";
import { API } from "@/api";

import { dig } from "@matchlighter/common_library/lib/macro";

import { SelectProps } from "@instructure/ui-select";
import { Flex } from "@instructure/ui-flex";
import { Text } from '@instructure/ui-text';
import { View } from "@instructure/ui-view";
import { IconSearchLine } from '@instructure/ui-icons';

interface CampusSearchSelectorProps extends SelectProps {
    onOptionSelected: (opt: any) => void;
}

export class CampusSelector extends Component<{ district: District } & ComponentProps<typeof AsyncSelect>> {
    fetchCampuses = async (term) => {
        const response = await API.get(`/api/v1/campuses`, {
            params: { district: this.props.district.id, page: 'all' },
        });
        return response.data['items'];
    }

    // private lastCampusFetch: AxiosResponse;
    // fetchCampuses = async (term, distId) => {
    //     const response = this.lastCampusFetch = await compareRequests({
    //         method: 'GET',
    //         url: `api/v1/campuses`,
    //         params: { district: distId },
    //     }, this.lastCampusFetch)

    //     return response.data['items'];
    // }

    render() {
        const { district, ...pass } = this.props
        return <AsyncSelect
            {...pass}
            options={this.fetchCampuses}
            should_cache_options={false}
            interaction={district ? pass.interaction : 'disabled'}
            placeholder={district ? pass.placeholder : "Select a District"}
        />
    }
}

export class CampusSearchSelector extends Component<CampusSearchSelectorProps> {

    async searchCampus(term: string) {
        if (term && term.length < 3) throw new FetchUserError("Type at least 3 characters to search");

        const params: any = {};
        if (term) params['search_term'] = term;
        params['state'] = 'any';

        const response = await API.get(`api/v1/campuses/`, { params })
        const items: any[] = response.data['items'];
        return items;
    }

    renderCampusSearchOption = (camp: any, meta: OptionMeta) => {
        const inverse = (meta.selected || meta.highlighted) ? '-inverse' : '';
        return <>
            <Flex>
                <Flex.Item margin="0 small 0 0">
                    <Text color={'primary' + inverse} >
                        {camp.name}
                    </Text>
                </Flex.Item>
            </Flex>
            <Flex as="div">
                <Flex.Item>
                    {camp.workflow_state == 'archived' ?
                        <View>
                            <Text color="secondary" transform="uppercase" letterSpacing="expanded" size="x-small" weight="bold">
                                {camp.workflow_state}
                            </Text> &nbsp;|&nbsp;&nbsp;</View> : ""
                    }
                </Flex.Item>
                <Flex.Item>
                    <Text color={'primary' + inverse} weight="bold" size="x-small">
                        Code:&nbsp;
                    </Text>
                    <Text color={'primary' + inverse} size="x-small">
                        {dig(camp.campus_code)}
                    </Text>
                </Flex.Item>
                <Flex.Item>
                    {dig(camp.district.name) ? <View>&nbsp;|&nbsp;&nbsp;
                        <Text color={'primary' + inverse} weight="bold" size="x-small">
                            District:&nbsp;
                        </Text>
                        <Text color={'primary' + inverse} size="x-small">
                            {dig(camp.district.name)}
                        </Text> </View> : ""
                    }
                </Flex.Item>
            </Flex>
        </>
    }

    render() {
        const { ...pass } = this.props
        return <AsyncSelect
            options={this.searchCampus}
            selectedOption={null}
            renderOption={this.renderCampusSearchOption}
            minSearchLength={3}
            icon={IconSearchLine}
            {...pass}
        />
    }
}